import { useListContext } from 'framework/list';
import { Badge } from 'framework/ui/mui-builder';
import { Box, Typography } from '@mui/material';

interface ApplicationsCollapseHeaderProps {
  title: string;
}

const ApplicationsCollapseHeader = ({ title }: ApplicationsCollapseHeaderProps) => {
  const { data, loading } = useListContext();
  const { totalElements = 0 } = data || {};

  return (
    <Box className="collapse-title-wrapper" sx={{ display: 'flex', alignItems: 'center' }}>
      <Typography variant="h3" mr={1} className="collapse-title">
        {title}
      </Typography>
      {loading ? null : <Badge>{totalElements}</Badge>}
    </Box>
  );
};

export default ApplicationsCollapseHeader;
